module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAAAXNSR0IArs4c6QAAAT5JREFUSEvtlDFKxFAURc8FC5dgYeESBBtL3YF2ioiINoKFC7DQFWgjY+eAglipOxjBwkJwBaKFgkuwu/LgB2JmMj+jBAb0QSD5P3nnvftuvmg51HJ+/hDA9hRwDtxIOmkqbSOJbM9FYmA6Je4CO5I+c6AswPYGcApMAPvAEjAPPMa9pPdhkFqA7Uh4BOwCH8CqpF5a7wDbaX1F0l0dZCAg6X0JLKRKlyW9lZPY3kqdxfJe3Vz6ABW9h2ptO6S6BsIAXUmb1U4GAV7SMGurqnQSyQMSsJDrqrw/CGCgJ2kx55Bi3/Ys8AQcSDpsAzADROdjDLB9Vmo9/ubbkkS/78B2zKaIb1LYHj/AQ1iu4qLX0vMxEFcRcUbdNx1y2C1s95NYl3SRs2lUswZMjkh4riaP77On6YiQvtf/AVkFvwBNeJwZnzIwNwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/headingIcons/homeActive.png
// module id = 7Qvr
// module chunks = 1